import { Typography } from "@mui/material";

export default function Footer({color='text.secondary'}) {
  return (
   <footer style={{marginBlock:'30px'}}>
        <Typography sx={{textAlign:'center', fontFamily:'Merriweather Sans', fontSize:16, color:color}}>
          &copy; {new Date().getFullYear()} mygospelpass.com — <a href="https://www.mygospelpass.com/mentions-legales" style={{color:'inherit'}} target="_blank" rel="noopener noreferrer">Mentions légales</a>
        </Typography>
    </footer>
  );
}